import {
  DeliveryContainerModuleDto,
  Dimensions3D,
  KnownDeliveryContainerDtoType,
  LockerDto
} from '@groundfloor-platform/mgmt-service-g-sdk';
import { Kiosk } from '../../../ui/components/pure/icons/Kiosk.icon';
import { LockerDC } from '../../../ui/components/pure/icons/LockerDC.icon';
import { LockerL } from '../../../ui/components/pure/icons/LockerL.icon';
import { LockerLR } from '../../../ui/components/pure/icons/LockerLR.icon';
import { LockerM } from '../../../ui/components/pure/icons/LockerM.icon';
import { LockerMR } from '../../../ui/components/pure/icons/LockerMR.icon';
import { LockerS } from '../../../ui/components/pure/icons/LockerS.icon';
import { LockerTL } from '../../../ui/components/pure/icons/LockerTL.icon';
import { LockerXL } from '../../../ui/components/pure/icons/LockerXL.icon';
import { LockerXLH } from '../../../ui/components/pure/icons/LockerXLH.icon';
import { LockerXS } from '../../../ui/components/pure/icons/LockerXS.icon';
import { LockerXXXL } from '../../../ui/components/pure/icons/LockerXXXL.icon';
import { SVGIconComponent } from '../../../ui/components/pure/icons/types';
import { DeliveryContainer } from './delivery-container.model';
import { PixelDimensions2D } from './pixel-dimensions-2d.model';
import { PixelPosition2D } from './pixel-position-2d.model';

export class Locker extends DeliveryContainer {
  public readonly sizeName: string;
  public readonly sizeDescription: string;
  public readonly tower: DeliveryContainerModuleDto;

  private readonly centimeterToPixelRatio = 1;
  private readonly towerDimensions?: Dimensions3D;

  constructor(locker: LockerDto, towerDimensions?: Dimensions3D) {
    super(locker, KnownDeliveryContainerDtoType.Locker, locker.tower);
    this.sizeName = locker.sizeName;
    this.sizeDescription = locker.sizeDescription;
    this.tower = locker.tower;
    this.towerDimensions = towerDimensions;
  }

  public get pixelDimensions2D() {
    return new PixelDimensions2D(
      this.uiOuterDimensions.widthCm,
      this.uiOuterDimensions.heightCm,
      this.centimeterToPixelRatio
    );
  }

  public get pixelPosition2D() {
    return new PixelPosition2D(this.uiPosition.x, this.uiPosition.y, this.centimeterToPixelRatio);
  }

  public get invertedPixelPosition2D() {
    const invertedXPosition = this.towerDimensions!.widthCm - this.uiPosition.x - this.uiOuterDimensions.widthCm;
    return new PixelPosition2D(invertedXPosition, this.uiPosition.y, this.centimeterToPixelRatio);
  }

  public get sizeIcon() {
    if (this.isKiosk) {
      return Kiosk;
    }
    const map: Record<string, SVGIconComponent> = {
      xs: LockerXS,
      s: LockerS,
      m: LockerM,
      l: LockerL,
      xl: LockerXL,
      dc: LockerDC,
      mf: LockerMR,
      lf: LockerLR,
      tl: LockerTL,
      xlh: LockerXLH,
      xxxl: LockerXXXL
    };

    return map[this.sizeName.toLowerCase()];
  }
}
